orders-planner-line-forward
  span.btn.btn-sm.btn-outline-danger.waves-effect.waves-dark.icon-btn(if="{this.isShow}" onClick="{onClick}" data-toggle="tooltip" data-placement="top" data-original-title="{this.tooltipValue}")
    i.feather.icon-skip-forward
  script(type="typescript").
    this.mixin('orders.planner.line-forward');
